import productInstance from '../../product/instance'

const getCategoryDiscount = ({ companyIndex, module = 'KASSA', categoryId, orderType }) => {
	return productInstance.get(`/${companyIndex}/categoryDiscounts/${module}?categoryId=${categoryId}`
		+ (orderType ? '&orderType=' + orderType : '')
	)
}

export default getCategoryDiscount
